import { Component, OnInit, Input } from '@angular/core';
import { AnouncementItem } from '../../../models/anouncementItem';
import { IList } from '../../../../core/interface/IList';
import * as moment from 'moment';
import { log } from 'util';

@Component({
    selector: 'app-anouncement',
    templateUrl: './anouncement.component.html',
    styleUrls: ['./anouncement.component.css']
})
export class AnouncementComponent implements OnInit {

    @Input() anoData: IList<AnouncementItem>;

    constructor() { }

    ngOnInit() {

    }

    today(item) {
        return moment(item.createDate, 'YYYY-MM-DD HH:mm:ss').isAfter(moment().add(-1, 'days'));
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/home/anouncement/anouncement.component.ts